module.exports = function getResource(label) {
    const resources = { legalMessage: 'Product reviews are managed by a third party to verify authenticity and compliance with our' /* Ratings & Reviews guidelines */ };
    return resources[label];
};
